/**
 * Update citation URL with text fragment (simplified version without polyfill)
 * @param {Selection} selection The current selection.
 * @returns {string} The updated citation URL.
 */
export function getCitationUrl(selection) {
    let url = `${location.origin}${location.pathname}${location.search}`;
    
    // Only add text fragment if there's a selection and browser supports it
    if (selection && selection.toString().trim()) {
        const selectedText = selection.toString().trim();
        
        // Check if browser supports text fragments natively
        if ('fragmentDirective' in document) {
            // Create a simple text fragment with just the selected text
            const encodedText = encodeURIComponent(selectedText);
            url += `#:~:text=${encodedText}`;
        }
        // If no native support, just return the URL without text fragment
    }
    
    return url;
}